(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ol-instant-delivery"] && !Shopify.designMode) return;
  try {
    function olSyncInstantDelivery(scope) {
    if (!scope || !scope.querySelector) return;
    const field = scope.querySelector('[data-olusb-feld]');
    const postal = Boolean(field && field.checked);
    scope.querySelectorAll('[data-ol-instant-offer]').forEach((offer) => { offer.hidden = postal; });
    scope.querySelectorAll('[data-ol-delivery-fallback]').forEach((row) => { row.hidden = !postal; });
    scope.querySelectorAll('.ol-delivery-options__usb').forEach((row) => { row.classList.toggle('is-selected', postal); });
  }
  function olInitInstantDelivery() {
    document.querySelectorAll('[data-ol-instant-offer]').forEach((offer) => {
      olSyncInstantDelivery(offer.closest('.shopify-section'));
    });
  }
  document.addEventListener('change', (event) => {
    if (event.target instanceof Element && event.target.matches('[data-olusb-feld]')) {
      olSyncInstantDelivery(event.target.closest('.shopify-section'));
    }
  });
  document.addEventListener('shopify:section:load', olInitInstantDelivery);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', olInitInstantDelivery, { once: true });
  else olInitInstantDelivery();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ol-shopvote"] && !Shopify.designMode) return;
  try {
    (function(){
  var dialog=document.getElementById('ol-sv-dialog');
  if(!dialog)return;
  var badge=document.querySelector('[data-ol-sv-preview-trigger]');
  if(badge){
    var preview=badge.querySelector('.ol-sv-preview');
    var previewFrame=badge.querySelector('[data-ol-sv-preview-frame]');
    var motion=window.matchMedia('(prefers-reduced-motion: reduce)');
    var dismissed=false;
    function hidePreview(){
      preview.hidden=true;
      previewFrame.removeAttribute('src');
    }
    function showPreview(){
      if(dismissed||!badge.getClientRects().length||dialog.open)return;
      preview.hidden=false;
      if(!previewFrame.getAttribute('src')){
        previewFrame.setAttribute('sandbox',motion.matches?'allow-same-origin':'allow-scripts allow-same-origin');
        previewFrame.src=previewFrame.dataset.src;
      }
    }
    badge.addEventListener('pointerenter',function(event){if(event.pointerType==='mouse')showPreview();});
    badge.addEventListener('pointerleave',function(){dismissed=false;if(!badge.matches(':focus-visible'))hidePreview();});
    badge.addEventListener('focus',function(){if(badge.matches(':focus-visible'))showPreview();});
    badge.addEventListener('blur',function(){if(!badge.matches(':hover'))hidePreview();dismissed=false;});
    badge.addEventListener('pointerdown',function(event){event.preventDefault();});
    document.addEventListener('keydown',function(event){if(event.key==='Escape'&&!preview.hidden){dismissed=true;hidePreview();}});
    document.addEventListener('visibilitychange',function(){if(document.hidden)hidePreview();});
    motion.addEventListener('change',function(){if(!preview.hidden){hidePreview();showPreview();}});
    document.addEventListener('click',function(event){if(!badge.contains(event.target))hidePreview();});
  }
  var lastTrigger;
  document.addEventListener('click',function(event){
    var target=event.target.closest('[data-ol-sv-open],a[href*="shopvote.de/bewertung_"]');
    if(!target||target.closest('.ol-sv-dialog'))return;
    event.preventDefault();lastTrigger=target;
    var frame=dialog.querySelector('[data-ol-sv-frame]');
    if(!frame.getAttribute('src'))frame.src=frame.dataset.src;
    if(!dialog.open)dialog.showModal();
  });
  dialog.querySelector('[data-ol-sv-close]').addEventListener('click',function(){dialog.close();});
  dialog.addEventListener('click',function(event){if(event.target===dialog){var r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  dialog.addEventListener('close',function(){if(lastTrigger)lastTrigger.focus({preventScroll:true});});
})();
  } catch(e) { console.error(e); }
})();

})();
